// src/components/TripsList.jsx
import React from 'react';
import { useSelector } from 'react-redux';

export function TripsList() {
  const trips = useSelector(s => s.dashboard.tripsList);

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">Trips</h3>
        <button className="text-blue-600 text-sm font-medium">See All</button>
      </div>
      <div className="space-y-3 overflow-auto">
        {trips.map(({ id, passenger, date, status, amount, avatar }) => (
          <div key={id} className="flex items-center p-3 rounded-lg hover:bg-gray-50 transition">
            <img src={avatar} alt="" className="w-10 h-10 rounded-full object-cover" />
            <div className="ml-3 flex-1">
              <p className="font-medium text-gray-900">{passenger}</p>
              <p className="text-xs text-gray-500">{date}</p>
            </div>
            <div className="text-right">
              <span className={`inline-block px-2 py-1 text-xs rounded-full ${
                status==='Active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
              }`}>
                {status}
              </span>
              <p className="mt-1 font-semibold text-gray-900">{amount}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
